// @flow

import React from 'react';
import useSheet from 'app/jss';
import { noop } from 'lodash';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  onClick?: () => void,
  classes: Object,
  children: any,
  onRef?: any,
};

const defaultProps = {
  onClick: noop,
  onRef: undefined,
};

function FriendDetailsHeader({ classes, onClick, children, onRef }: Props) {
  if (!onClick) {
    return (
      <div ref={onRef} component="div" className={classes.friendHeader} onTap={onClick}>
        {children}
      </div>
    );
  }

  return (
    <Tappable ref={onRef} component="div" className={classes.friendHeader} onTap={onClick}>
      {children}
    </Tappable>
  );
}

FriendDetailsHeader.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    friendHeader: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: 15,
      width: '100%',
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.1s',
      backgroundColor: theme.color.white,
    },
  };
}

export default useSheet(applyStyles)(FriendDetailsHeader);
